import { render, staticRenderFns } from "./TrainingAsignmentDetail.vue?vue&type=template&id=4ae3206d"
import script from "./TrainingAsignmentDetail.js?vue&type=script&lang=js&external"
export * from "./TrainingAsignmentDetail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports